import React, { forwardRef } from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkRehype from 'remark-rehype';
import rehypeRaw from 'rehype-raw';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { useTheme } from '@/Contexts/ThemeProvider';
import { cn } from '@/utils';
import CodeToolbar from '@/Components/CodeToolbar';

const MD = forwardRef<
  HTMLDivElement,
  { markdown: string; className?: string; chat: App.Data.ChatData }
>((props, ref) => {
  const { codeHighlight } = useTheme();

  return (
    <div
      ref={ref}
      className={cn(
        'prose w-full max-w-none overflow-hidden break-words dark:prose-invert prose-code:break-all prose-pre:relative prose-pre:max-w-full prose-pre:overflow-x-auto prose-pre:whitespace-pre-wrap prose-pre:rounded-none prose-pre:bg-transparent prose-pre:p-0',
        props.className
      )}
    >
      <Markdown
        children={props.markdown}
        remarkPlugins={[remarkBreaks, remarkRehype]}
        rehypePlugins={[rehypeRaw]}
        components={{
          code(props) {
            const { children, className, node, ...rest } = props;
            const match = /language-(\w+)/.exec(className || '');
            return match ? (
              <div className="rounded-xl dark:bg-brand-dark-75">
                {children && (
                  <CodeToolbar code={children.toString()} language={match[1]} />
                )}

                <SyntaxHighlighter
                  {...rest}
                  children={String(children).replace(/\n$/, '')}
                  style={codeHighlight}
                  language={match[1]}
                  PreTag="div"
                />
              </div>
            ) : (
              <code {...rest} className={className}>
                {children}
              </code>
            );
          },
        }}
      />
    </div>
  );
});

export default MD;
